import axios from 'axios'
import store from '@/store'
import router from '@/router'
import config from '@/config'
import { Notice } from 'view-design'
import optionExtend from './requestOptionExtend'

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url, options) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data, status } = res
      return { data, status }
    }, error => {
      if (error.response) {
        if (error.response.status === 401) {
          store.commit('setToken', '')
          router.replace({
            path: config.LOGIN_PAGE_PATH,
            query: { redirect: router.currentRoute.fullPath }
          })
          Notice.error({
            title: '登录已过期, 请重新登录！'
          })
        } else if (error.response.status === 412 && options.needPrivateCloudProjectHeader) {
          router.replace({
            name: 'private_cloud_not_project'
          })
          this.destroy(url)
          return Promise.reject(error)
        } else {
          this.destroy(url)
          return Promise.reject(error)
        }
      }
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    options = optionExtend(options)
    this.interceptors(instance, options.url, options)
    return instance(options)
  }
}
export default HttpRequest
